import React from 'react'
import { ThreadListSkeleton } from './ThreadListSkeleton'
import { MessageAreaSkeleton } from './MessageAreaSkeleton'

export const ChatSkeleton: React.FC = () => (
  <div className="flex h-full w-full bg-white dark:bg-background overflow-hidden">
    <ThreadListSkeleton />
    <MessageAreaSkeleton />
  </div>
)
